import React from 'react';
import { Box, Rating, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

const StarRating = ({
  value = 0,
  onChange,
  readOnly = false,
  size = 'medium',
  showLabel = false,
  precision = 0.5
}) => {
  const labels = {
    0.5: '很差',
    1: '差',
    1.5: '不太好',
    2: '一般',
    2.5: '還可以',
    3: '普通',
    3.5: '不錯',
    4: '好',
    4.5: '很好',
    5: '非常好',
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Rating
        value={value}
        onChange={(event, newValue) => {
          if (onChange && !readOnly) {
            onChange(newValue);
          }
        }}
        readOnly={readOnly}
        precision={precision}
        size={size}
        emptyIcon={<StarIcon style={{ opacity: 0.3 }} fontSize="inherit" />}
        sx={{
          '& .MuiRating-iconFilled': {
            color: '#faaf00',
          },
        }}
      />
      {showLabel && value !== null && (
        <Typography variant="body2" color="text.secondary">
          {labels[value] || ''}
        </Typography>
      )}
    </Box>
  );
};

export default StarRating;
